export default __webpack_public_path__ + "static/demande.maro.mobile-a6693596c6da9950729f4b27f5fdc2e8.jpg";